import { useEffect } from "react";
import { queryClient } from "../../../App";
import { HttpClientError } from "../../../providers/HttpClient";
import useCancelPayslipDocumentProcessingJobApiService from "../services/api/CancelPayslipDocumentProcessingJobApiService";
import { useToasts } from "../../../providers/notifications/ToastsContext";

export default function CancelPayslipDocumentProcessingHook(
  documentName: string
): { cancelDocument: (request: number) => void } {
  const { showToast } = useToasts();
  const { isSuccess, isError, mutate, error } =
    useCancelPayslipDocumentProcessingJobApiService();

  const cancelDocument = (request: number): void => {
    mutate(request);
  };

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "cancel_payslip_upload_failed",
        data: { document_name: documentName, message: HttpClientError(error) },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      showToast({
        strapiId: "cancel_payslip_upload_success",
        data: { document_name: documentName },
      });
      queryClient.invalidateQueries(["DocumentUploadListApiService"]).then();
    }
  }, [isSuccess]);

  return {
    cancelDocument,
  };
}
